var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChips(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35px",
    height: "12px",
    viewBox: "0 0 35 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "90A9C687-54B4-4879-8B50-AAD267CEA910") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KIT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elementler-KIT",
    transform: "translate(-1237.000000, -4028.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5-Copy-7",
    transform: "translate(1237.000000, 4028.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    fill: "#464646",
    x: 0,
    y: 0,
    width: 15,
    height: 5,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-39",
    stroke: "#464646",
    strokeWidth: 0.5,
    x: 16.25,
    y: 0.25,
    width: 18.5,
    height: 4.5,
    rx: 2.25
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    stroke: "#464646",
    strokeWidth: 0.5,
    x: 0.25,
    y: 7.25,
    width: 20.5,
    height: 4.5,
    rx: 2.25
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-39",
    stroke: "#464646",
    strokeWidth: 0.5,
    x: 22.25,
    y: 7.25,
    width: 10.5,
    height: 4.5,
    rx: 2.25
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChips);
export default __webpack_public_path__ + "static/media/Chips.751749a7901d3caf51af8c939171d708.svg";
export { ForwardRef as ReactComponent };